export default function setSidebarStyle(pt) {
  const sidebarArea = document.querySelector("#sidebar-area");
  sidebarArea.style.paddingTop = `${pt}px`;
}
